export default {
  computed: {
    // Used by FeedbackForm / RecordingScorecard
    isRecordingCoach: {
      cache: false,
      get() {
        return !!this._.filter(this.$store.getters.activeGroups, group => {
          return this._.includes(group.roles, 'manager') && group.groupId === this.recording.groupId;
        }).length;
      }
    },
    showAddScore: {
      cache: false,
      get() {
        if (!this.hasCustomScorecard) {
          return !this.isMyRecording;
        }

        if (this.isMyRecording) {
          return false;
        }
        if (this.scorecard.coachOnlyScorecard) {
          return this.isRecordingCoach;
        }
        return true;
      }
    },
    showScoreCard: {
      cache: false,
      get() {
        if (!this.hasCustomScorecard) {
          return this.rawScores.length;
        }

        if (!this.rawScores.length) {
          return false;
        }

        if (this.isMyRecording) {
          return true;
        }
        if (this.scorecard.coachOnlyScorecard) {
          return this.isRecordingCoach;
        }
        return true;
      }
    },
    myScore: {
      cache: false,
      get() {
        let mine = null;
        this.rawScores.forEach((feedback) => {
          if (feedback.userId === this.$store.getters.user.userId) {
            mine = feedback;
          }
        });
        return mine;
      }
    },
    myResponse: {
      cache: false,
      get() {
        let mine = null;
        this.rawResponses.forEach((resp) => {
          if (resp.userId === this.$store.getters.user.userId) {
            mine = resp;
          }
        });
        return mine;
      }
    },
    feedback: {
      cache: false,
      get() {
        const allFeedback = this._.cloneDeep(this.$store.getters.feedback);
        const feedback = (this.recording && allFeedback && allFeedback[this.recording.recordingId]) ?
          allFeedback[this.recording.recordingId] : [];
        return this._.filter(feedback, (f) => f.comment);
      }
    },
    scores: {
      cache: false,
      get() {
        let scores = [];
        this.coreScores.forEach((_score) => {
          let score = this._.clone(_score);
          this.rawScores.forEach((rawScore) => {
            score.value += parseFloat(rawScore[score.apiName]) || 0;
          });
          score.value = score.value / this.rawScores.length;
          scores.push(score);
        });

        return scores;
      }
    },
    user() {
      return this.$store.getters.user;
    },

    // Used by other pages
    coreScores() {
      return this.$store.getters.appConfig.coreScores;
    },
    coreScoresByApiName() {
      return this._.map(this.$store.getters.appConfig.coreScores, (s) => s.apiName);
    },
    coachOnlyScores: {
      cache: false,
      get() {
        const peerRating = this._.find(this.rawScores, {isManager: true});
        return (peerRating && peerRating.length);
      }
    },
    rawResponses: {
      cache: false,
      get() {
        const allResponses = this.$store.getters.allResponses;
        if (this.recording) {
          let responses = (allResponses && allResponses[this.recording.recordingId]) ?
            allResponses[this.recording.recordingId] : [];
          return responses;
        }
        return allResponses;
      }
    },
    rawScores: {
      cache: false,
      get() {
        const allFeedback = this._.clone(this.$store.getters.feedback);
        if (this.recording) {
          const feedback = (this.recording && allFeedback && allFeedback[this.recording.recordingId]) ?
            allFeedback[this.recording.recordingId] : [];
          return this._.filter(feedback, (f) => f.scoreOverall);
        }
        return this._.forEach(
          allFeedback,
          (responses, recordingId) => {
            allFeedback[recordingId] = this._.filter(responses, (r) => r.scoreOverall);
          });
      }
    },
    scorecard: {
      cache: false,
      get() {
        if (this.recording) {
          return (this.recording.assignment && this.recording.assignment.scorecard &&
            this.recording.assignment.scorecard.scorecard) ?
            this.recording.assignment.scorecard.scorecard : null;
        }
        return (this.assignment && this.assignment.scorecard &&
          this.assignment.scorecard.scorecard) ?
          this.assignment.scorecard.scorecard : null;
      }
    },
    hasCustomScorecard: {
      cache: false,
      get() {
        return !!(this.scorecard);
      }
    },
    scorecardQuestionsForRecording: {
      cache: false,
      get() {
        return this.getScorecardQuestionsForRecording(
          this.recording, this.scorecard
        );
      }
    },

    scorecardQuestionsForAssignment: {
      cache: false,
      get() {
        // Check for customized scorecards
        let allScores = (this.hasCustomScorecard) ?
          this._.cloneDeep(this.scorecard.questions) :
          this._.cloneDeep(this.coreScores);

        allScores.forEach((_rating) => {
          if (this.hasCustomScorecard && !_rating.preset) {
            // Calculate custom fields from scorecardResponses
            // rawResponses is all responses for all recordings from Vuex
            this._.forEach(this.rawResponses, (responses, recordingId) => {
              // Now we have a recordingId and all its responses
              if (!_rating.recordings) {
                _rating.recordings = {};
              }

              if (!_rating.recordings[recordingId]) {
                _rating.recordings[recordingId] = {
                  responses: [],
                  mgrResponses: [],
                  avgScore: 0,
                  mgrAvgScore: 0,
                  totalScore: 0,
                  mgrTotalScore: 0,
                };
              }
              const rating = _rating.recordings[recordingId];
              responses.forEach((response) => {
                let match = this._.find(response.responses, {id: _rating.id});
                if (!match) { // Skip (hidden) fields that weren't answered
                  return;
                }
                match = this._.cloneDeep(match);
                match.isManager = response.isManager;
                match.userId = response.userId;

                if (!match || !match.response) return;

                // match looks like:  {id: 'overall', response: 4}
                rating.responses.push(match);
                rating.totalScore += parseInt(match.response, 10);
                rating.avgScore = Math.round(rating.totalScore / rating.responses.length * 100) / 100;

                // Now handle is_manager = true
                // Verified working: This is called by Download Report
                if (!match.isManager) return;
                rating.mgrResponses.push(match);
                rating.mgrTotalScore += parseInt(match.response, 10);
                rating.mgrAvgScore = Math.round(rating.mgrTotalScore / rating.mgrResponses.length * 100) / 100;
              });
            });
          }

          // Calculate presets from feedback
          if (_rating.preset) {
            this._.forEach(this.rawScores, (scores, recordingId) => {
              if (!_rating.recordings) {
                _rating.recordings = {};
              }

              if (!_rating.recordings[recordingId]) {
                _rating.recordings[recordingId] = {
                  responses: [],
                  mgrResponses: [],
                  avgScore: 0,
                  mgrAvgScore: 0,
                  totalScore: 0,
                  mgrTotalScore: 0,
                };
              }
              const rating = _rating.recordings[recordingId];
              scores.forEach((score) => {
                const response = {
                  id: _rating.id,
                  response: parseInt(score[_rating.apiName], 10),
                  isManager: score.isManager,
                  userId: score.userId,
                };
                if (!response.response) return;

                rating.responses.push(response);
                rating.totalScore += response.response;
                rating.avgScore = Math.round(rating.totalScore / rating.responses.length * 100) / 100;

                // Now handle is_manager = true
                // Verified working. This is called by Download Report
                if (!score.isManager) return;
                rating.mgrResponses.push(response);
                rating.mgrTotalScore += response.response;
                rating.mgrAvgScore = Math.round(rating.mgrTotalScore / rating.mgrResponses.length * 100) / 100;
              });
            });
          }
        });

        return allScores;
      }
    },
  },
  methods: {
    getScoreText(score) {
      const text = (this.recording.assignment && this.recording.assignment.metadata &&
        this.recording.assignment.metadata[score.apiName + 'Description']) ?
        this.recording.assignment.metadata[score.apiName + 'Description'] : score.description;
      return /^\s+$/.test(text) ? '' : text; // handle text that is all whitespace
    },
    getScorecardQuestionsForRecording(recording, scorecard) {
      const allScores = !!(scorecard) ?
        scorecard.scorecard ?
          this._.cloneDeep(scorecard.scorecard.questions) :
          this._.cloneDeep(scorecard.questions) :
        this._.cloneDeep(this.coreScores);

      const allResponses = this.$store.getters.allResponses;
      const rawResponses = (allResponses && allResponses[recording.recordingId]) ?
        allResponses[recording.recordingId] : [];
      const allFeedback = this._.cloneDeep(this.$store.getters.feedback);
      const rawScores = (this.recording && allFeedback && allFeedback[this.recording.recordingId]) ?
        this._.filter(allFeedback[this.recording.recordingId], (f) => f.scoreOverall) : [];

      allScores.forEach((rating) => {
        if (scorecard && !rating.preset) {
          // Calculate custom fields from scorecardResponses
          rawResponses.forEach((response) => {
            let match = this._.find(response.responses, {id: rating.id});
            if (!match) return; // Skip (hidden) fields that weren't answered

            match = this._.cloneDeep(match);
            match.isManager = response.isManager;
            match.userId = response.userId;

            // match looks like:  {id: 'overall', response: 4}
            if (!rating.responses) {
              rating.responses = [];
              rating.avgScore = 0;
              rating.totalScore = 0;
              rating.mgrResponses = [];
              rating.mgrAvgScore = 0;
              rating.mgrTotalScore = 0;
            }
            rating.responses.push(match);
            rating.totalScore += match.response;
            rating.avgScore = Math.round(rating.totalScore / rating.responses.length * 100) / 100;

            // Store the user's own score
            if (response.userId === this.$store.getters.user.userId) {
              rating.myScore = match.response;
            }

            // Verified working. This is called by Assignment Comparison & EVALUATE
            if (!response.isManager) return;
            rating.mgrResponses.push(match);
            rating.mgrTotalScore += match.response;
            rating.mgrAvgScore = Math.round(rating.mgrTotalScore / rating.mgrResponses.length * 100) / 100;
          });
        }

        // Calculate presets from feedback
        if (rating.preset) {
          rawScores.forEach((score) => {
            const response = {
              id: rating.id,
              response: score[rating.apiName],
              userId: score.userId,
              isManager: score.isManager,
            };
            if (!rating.responses) {
              rating.responses = [];
              rating.avgScore = 0;
              rating.totalScore = 0;
              rating.mgrResponses = [];
              rating.mgrAvgScore = 0;
              rating.mgrTotalScore = 0;
            }
            rating.responses.push(response);
            rating.totalScore += response.response;
            rating.avgScore = Math.round(rating.totalScore / rating.responses.length * 100) / 100;

            // Store the user's own score
            if (score.userId === this.$store.getters.user.userId) {
              rating.myScore = response.response;
            }

            // Verified working. This is called by EVALUATE
            if (!score.isManager) return;
            rating.mgrResponses.push(response);
            rating.mgrTotalScore += response.response;
            rating.mgrAvgScore = Math.round(rating.mgrTotalScore / rating.mgrResponses.length * 100) / 100;
          });
        }
      });
      return allScores;
    }
  },
};
